import { useEffect, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

// Adjust path based on your folder structure
import logo from "../assets/Whitelogo09122025.png";
import logoMotto from "../assets/Logo_Motto.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  // Scroll Detection Effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navLinks = [
    { label: "BUY VEHICLE", href: "/vehicle-listing" },
    { label: "SELL VEHICLE", href: "/sell-vehicle" },
    { label: "ABOUT", href: "/about" },
    { label: "ARTICLES", href: "/articles" },
    { label: "CONTACT US", href: "/contact-us" },
  ];

  const headerTextColor = isScrolled ? "#000" : "#fff";

  // ✅ DRAWER CONTENT
  const drawerContent = (
    <Box sx={{ textAlign: "center", p: 2 }}>
      <Box display="flex" justifyContent="flex-end">
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        component="img"
        src={logoMotto}
        alt="WorkHorse Logo"
        onClick={() => {
          navigate("/");
          setMobileOpen(false);
        }}
        sx={{ width: 140, my: 2, cursor: "pointer" }}
      />

      <Divider />

      <List>
        {navLinks.map((link) => (
          <ListItem key={link.label} disablePadding>
            <ListItemButton
              component="a"
              href={link.href}
              onClick={() => setMobileOpen(false)}
              sx={{ textAlign: "center" }}
            >
              <ListItemText primary={link.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Box mt={2}>
        <Button
          variant="contained"
          href="https://portalstaging.workhorse.com.sg"
          target="_blank"
          rel="noopener noreferrer"
          fullWidth
          sx={{
            backgroundColor: "#ffaa00",
            color: "#000",
            fontWeight: "bold",
            "&:hover": { backgroundColor: "#ffbc00" },
          }}
        >
          Login
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          px: { xs: 2, md: 4 },
          py: 2,
          zIndex: 100,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

          backgroundColor: isScrolled ? "#fff" : "transparent",
          background: isScrolled
            ? "#fff"
            : "linear-gradient(to bottom, rgba(0,0,0,0.55), rgba(0,0,0,0))",
          backdropFilter: "none",
          boxShadow: isScrolled ? "0px 4px 12px rgba(0,0,0,0.1)" : "none",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {/* LOGO */}
        <Box display="flex" alignItems="center">
          <Box
            component="img"
            src={isScrolled ? logoMotto : logo}
            alt="WorkHorse Logo"
            onClick={() => navigate("/")}
            sx={{
              width: { xs: 120, sm: 140, md: 170, lg: 190 },
              height: "auto",
              cursor: "pointer",
              objectFit: "contain",
              transition: "opacity 0.3s ease-in-out",
            }}
          />
        </Box>

        {/* DESKTOP NAV */}
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            gap: 3,
          }}
        >
          {navLinks.map((link) => (
            <Button
              key={link.label}
              variant="text"
              href={link.href}
              sx={{
                color: headerTextColor,
                textTransform: "uppercase",
                fontSize: 14,
                fontWeight: 600,
                transition: "color 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: isScrolled
                    ? "rgba(0,0,0,0.05)"
                    : "rgba(255, 188, 0, 0.1)",
                  color: "#ffbc00",
                },
              }}
            >
              {link.label}
            </Button>
          ))}
          <Button
            variant="contained"
            href="https://portalstaging.workhorse.com.sg"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "#ffaa00",
              color: "#000",
              fontWeight: "bold",
              ml: 1,
              "&:hover": { backgroundColor: "#ffbc00" },
            }}
          >
            Login
          </Button>
        </Box>

        {/* MOBILE MENU ICON */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{
            display: { sm: "none" },
            color: headerTextColor,
          }}
        >
          <MenuIcon />
        </IconButton>
      </Box>

      {/* MOBILE DRAWER COMPONENT */}
      <Drawer
        anchor="right"
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
};

export default Header;